var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSideCloseLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-side-close-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3 6C9.3 5.50294 9.70294 5.1 10.2 5.1H21C21.4971 5.1 21.9 5.50294 21.9 6C21.9 6.49705 21.4971 6.9 21 6.9L10.2 6.9C9.70294 6.9 9.3 6.49706 9.3 6Z",
    fill: "#8D9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6364 9.0364C6.98787 8.68492 6.98787 8.11508 6.6364 7.7636C6.28492 7.41213 5.71508 7.41213 5.3636 7.7636L1.7636 11.3636C1.41213 11.7151 1.41213 12.2849 1.7636 12.6364L5.3636 16.2364C5.71508 16.5879 6.28492 16.5879 6.6364 16.2364C6.98787 15.8849 6.98787 15.3151 6.6364 14.9636L3.67279 12L6.6364 9.0364Z",
    fill: "#8D9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 11.1C9.70294 11.1 9.3 11.5029 9.3 12C9.3 12.4971 9.70294 12.9 10.2 12.9L18.6 12.9C19.0971 12.9 19.5 12.4971 19.5 12C19.5 11.5029 19.0971 11.1 18.6 11.1L10.2 11.1Z",
    fill: "#8D9299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 17.1C9.70294 17.1 9.3 17.5029 9.3 18C9.3 18.4971 9.70294 18.9 10.2 18.9L21 18.9C21.4971 18.9 21.9 18.4971 21.9 18C21.9 17.5029 21.4971 17.1 21 17.1L10.2 17.1Z",
    fill: "#8D9299"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSideCloseLeft);
export default __webpack_public_path__ + "static/media/icon-side-close-left.7ada4dbd3bd7140b640371f58b92b815.svg";
export { ForwardRef as ReactComponent };